/** Formatting for review request analytics. */

/** "45s", "14m", "2h 05m", "1d 3h". */
export function formatDuration(seconds: number | null): string {
  if (seconds === null) return '—';
  if (seconds < 60) return `${Math.round(seconds)}s`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ${String(minutes % 60).padStart(2, '0')}m`;
  return `${Math.floor(hours / 24)}d ${hours % 24}h`;
}

export function formatMinutes(minutes: number | null): string {
  return minutes === null ? '—' : formatDuration(minutes * 60);
}

/** "42%" or "—" when there is nothing to divide by. */
export function percent(num: number, den: number): string {
  return den === 0 ? '—' : `${Math.round((num / den) * 100)}%`;
}

export function rateText(rate: number | null): string {
  return rate === null ? '—' : `${Math.round(rate)}%`;
}

export function usd(n: number): string {
  return `$${n.toFixed(2)}`;
}

/** Change against the previous period: "+4", "−2", or null when equal or unknown. */
export function deltaText(current: number | null, previous: number | null): string | null {
  if (current === null || previous === null) return null;
  const d = Math.round((current - previous) * 10) / 10;
  if (d === 0) return null;
  return d > 0 ? `+${d}` : `−${Math.abs(d)}`;
}
